import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const ListingViewSidebarEventHost_Hide_1 = styled.div`
  display: none;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: block;
  }
`;
